import { useCallback, useState } from 'react';
import { initialValues, type SearchFormValues } from '../schema';

export const useSearchDialog = () => {
  const [open, setOpen] = useState(true);
  const [searchParams, setSearchParams] = useState<SearchFormValues>(initialValues);
  const [hasSearched, setHasSearched] = useState(false);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onSubmit = useCallback((values: SearchFormValues) => {
    setSearchParams(values);
    setHasSearched(true);
    setOpen(false);
  }, []);

  return {
    open,
    searchParams,
    hasSearched,
    onOpen,
    onClose,
    onSubmit
  };
};
